import moment from "moment-timezone";
import { useWatch } from "rc-field-form";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import {
	combineDateAndTime,
	renderDurationAsFormat,
} from "../../../utils/helpers/date";
import { areBreaksPaid } from "../../../utils/helpers/shift";
import { useCompanyTimeFormat } from "../../../utils/hooks/company";
import { useUser } from "../../../utils/hooks/user";

const MAX_DURATION = moment.duration(1, "day").asSeconds();

function PaidHours() {
	const { t } = useTranslation();
	const user = useUser();
	const timeFormat = useCompanyTimeFormat();
	const values = useWatch();

	const breaksPaid = areBreaksPaid(user?.calculationGroup?.breaks);

	let hours = renderDurationAsFormat(0, timeFormat);
	let duration = 0;

	if (
		values?.start?.date &&
		values?.start?.time &&
		values?.end?.date &&
		values?.end?.time
	) {
		const start = combineDateAndTime(
			values?.start?.date,
			values?.start?.time,
		);
		const end = combineDateAndTime(values?.end?.date, values?.end?.time);

		duration = end.diff(start, "seconds");

		if (!breaksPaid) {
			let breaks = 0;
			values?.breaks?.map(({ start, end }) =>
				start && end
					? (breaks += moment(end).diff(moment(start), "seconds"))
					: (breaks += 0),
			);
			hours = renderDurationAsFormat(duration - breaks, timeFormat);
		} else {
			hours = renderDurationAsFormat(duration, timeFormat);
		}
	}

	return (
		<div className="m-0 py-2 d-flex justify-content-between">
			<h4 className="text-primary mr-1">{t("total-paid-hours")}</h4>

			<h4 className={classNames("text-primary d-flex gap-x-2", duration >= MAX_DURATION && "text-danger")}>
				{duration >= MAX_DURATION && <FontAwesomeIcon icon={faWarning} size="sm" className="pb-0 mb-0 mt-1" />}
				<div className="d-flex flex-column">
					{hours}
					{duration >= MAX_DURATION && <span className="text-xs">({t("exceeds-24-hour")})</span>}
				</div>
			</h4>
		</div>
	);
}

export default PaidHours;
